import { linkToFacilities } from "#routers/links";
import { RoutingLink } from "#src/batteries-included-components/RoutingLink";
import {
  useClientSideSortingAndPagination,
  useTableSortingAndPagination,
} from "#src/components/Redux/reducers/tableStateReducer";
import { DataTable } from "@validereinc/common-components";
import type { FlowType } from "@validereinc/domain";
import React, { useMemo } from "react";
import { useStorageKey } from "#src/hooks/useStorageKey";

export const FlowFacilityTable = ({
  variant,
  flow,
  isLoading,
}: {
  variant: "upstream" | "downstream";
  flow?: FlowType;
  isLoading: boolean;
}) => {
  const facilityDetail = useMemo(
    () => flow?.[`${variant}_facility`] ?? { id: undefined },
    [flow]
  );
  const [tableStateStorageKey] = useStorageKey(
    ["table-state"],
    "flows-facility"
  );
  const [tableState, updateTableState] = useTableSortingAndPagination(
    undefined,
    undefined,
    tableStateStorageKey
  );
  const { items, pagination, sorting } = useClientSideSortingAndPagination(
    [{ ...facilityDetail, type: "Facility" }],
    tableState
  );

  const facilityId = flow?.[`${variant}_facility_id`] ?? "";

  return (
    <DataTable
      isLoading={isLoading}
      items={items}
      getItemId={() => facilityId}
      headers={[
        {
          label: "Name",
          key: "name",
          renderComponent: ({ item }: any) => (
            <RoutingLink to={linkToFacilities(facilityId)}>
              {item.name}
            </RoutingLink>
          ),
        },
        {
          label: "Type",
          key: "type",
        },
      ]}
      pagination={{
        ...pagination,
        showPageSizeControls: false,
      }}
      sorting={sorting}
      onPaginationChange={updateTableState}
      onSortChange={updateTableState}
    />
  );
};
